import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'text-with-link',
  templateUrl: './text-with-link.component.html'
})
export class TextWithLinkComponent {

  @Input()
  preText!: string;

  @Input()
  linkText!: string;

  @Output()
  clickChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() {
  }

  onRetry(event: Event): void {
    event.preventDefault();
    this.clickChange.emit();
  }
}
